/**
 * How a deal's status reads on screen, in one place: a chip for won and lost,
 * and — in a "stage" column — the stage name while the deal is open, because
 * an open deal's stage is what matters and a closed one's is history.
 */
import { useTranslation } from 'react-i18next';
import Chip from '@mui/material/Chip';
import type { DealDto, DealStatus } from '@forsys/shared';

export function DealStatusChip({ status }: { status: DealStatus }) {
  const { t } = useTranslation('crm');
  return <Chip size="small" color={status === 'won' ? 'success' : 'default'} label={t(`status.${status}`)} />;
}

/** The stage of an open deal, or the status of a closed one. For a list's "stage" column. */
export function DealStageOrStatus({ deal }: { deal: DealDto }) {
  return deal.status === 'open' ? <>{deal.stage.name}</> : <DealStatusChip status={deal.status} />;
}
